// components/ReflectionCards.jsx

import reflectionCard from "../../assets/mysamadhi.png";

export default function ReflectionCards() {
  return (
    <>
      <style>{`
        .reflection-grid{
          display:flex;
          gap:40px;
          align-items:center;
          justify-content:space-between;
          flex-wrap:wrap;
        }

        .reflection-stack{
          position:relative;
          width:350px;
          height:450px;
          margin:auto;
        }

        .reflection-img{
          position:absolute;
          width:100%;
          border-radius:28px;
          overflow:hidden;
          border:1px solid rgba(201,168,76,0.14);
          box-shadow:0 20px 60px rgba(0,0,0,0.35);
          transition:all 0.45s ease;
          background:#080604;
        }

        .reflection-img img{
          width:100%;
          display:block;
          object-fit:cover;
        }

        .reflection-img:nth-child(1){
          transform:
            rotate(-7deg)
            translateX(-30px)
            translateY(40px);

          opacity:0.6;
        }

        .reflection-img:nth-child(2){
          transform:
            rotate(6deg)
            translateX(40px)
            translateY(10px);

          opacity:0.75;
        }

        .reflection-img:nth-child(3){
          transform:
            rotate(-2deg)
            translateY(-10px);

          z-index:5;
        }

        .reflection-img:hover{
          transform:
            scale(1.03)
            translateY(-8px);

          z-index:20;
          opacity:1 !important;
        }

        @media(max-width:1000px){
          .reflection-grid{
            flex-direction:column;
            align-items:stretch;
          }

          .reflection-left{
            max-width:100% !important;
          }

          .reflection-stack{
            width:100%;
            max-width:380px;
            height:460px;
          }
        }

        @media(max-width:700px){
          .reflection-wrapper{
            padding:30px 18px !important;
          }

          .reflection-title{
            font-size:36px !important;
          }

          .reflection-body{
            font-size:17px !important;
          }

          .reflection-stack{
            height:400px;
          }
        }
      `}</style>

      <div
        className="reflection-wrapper"
        style={{
          width: "100%",
          padding: "60px",
          borderRadius: "34px",
          border:
            "1px solid rgba(201,168,76,0.12)",
          background:
            "linear-gradient(to bottom, rgba(201,168,76,0.04), rgba(201,168,76,0.015))",
          overflow: "hidden",
        }}
      >
        <div className="reflection-grid">
          {/* LEFT */}
          <div
            className="reflection-left"
            style={{
              flex: 1,
              minWidth: "320px",
              maxWidth: "500px",
            }}
          >
            <span
              style={{
                color: "rgba(201,168,76,0.55)",
                fontFamily: "var(--fell)",
                fontSize: "12px",
                letterSpacing: "2px",
              }}
            >
              SHARED REFLECTIONS
            </span>

            <h2
              className="reflection-title"
              style={{
                marginTop: "22px",
                marginBottom: "26px",
                color: "var(--parch)",
                fontFamily: "var(--fell)",
                fontSize: "40px",
                lineHeight: 1.1,
                fontWeight: 400,
              }}
            >
              Share conversation cards with friends and discover deeper similarities.
            </h2>

            <p
              className="reflection-body"
              style={{
                color: "var(--parch3)",
                fontFamily: "var(--corm)",
                fontStyle: "italic",
                fontSize: "22px",
                lineHeight: 1.9,
              }}
            >
              Emotional guidance, deep questions,
              reflections and conversations shared
              through interactions with AI companions.
            </p>
          </div>

          {/* RIGHT */}
          <div
            style={{
              flex: 1,
              minWidth: "300px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="reflection-stack">
              <div className="reflection-img">
                <img
                  src={reflectionCard}
                  alt="AI reflection card conversation"
                />
              </div>

              <div className="reflection-img">
                <img
                  src={reflectionCard}
                  alt="Emotional guidance card"
                />
              </div>

              <div className="reflection-img">
                <img
                  src={reflectionCard}
                  alt="Shared Mysamadhi reflection"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}